import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import ActivityTile from 'components/activity-display/layouts/ActivityTile';
import ActivityCard from 'components/activity-display/layouts/ActivityCard';
import { Activity, ActivityCategory } from 'interfaces/ActivityInterfaces';
import PaddingWrap from 'components/shared/PaddingWrap';
import { useUI } from 'hooks/useUI';
import ActivityCategoryDisplay from 'components/activity-display/ActivityCategoryDisplay';

type GridLayouts = 'tiles' | 'cards';

interface ActivityGridProps {
	activities: Activity[];
	layout: GridLayouts;
	activityCategory: ActivityCategory | null;
}

function ActivityGrid({ activities, layout, activityCategory }: ActivityGridProps) {
	const { appWidth } = useUI();

	const gridColumnWidth = appWidth > 2000 ? 2 : //6 tiles per row
		appWidth > 1600 ? 3 :    //4 tiles per row
		appWidth > 1200 ? 4 :     //3 tiles per row
		appWidth > 650 ? 6 : 12; //1 tile per row

	/* if (activities === null) {
		// If activities are null, render skeletons
		const skeletons = Array.from({ length: 9 }, (_, index) => (
		<Grid xs={gridColumnWidth} key={index}>
		</Grid>
		));

		return (
		<div ref={activityGridRef}>
			<Grid container spacing={0}>
			{skeletons}
			</Grid>
		</div>
		);
	} */

	function renderActivityGridLayout(activities: Activity[], layout: GridLayouts) {
		switch (layout) {
			case 'tiles':
				return (
					<Grid container spacing={0}>
						{activities.map((activity:Activity) => {
							return(
								<Grid key={activity.id} xs={gridColumnWidth}>
									<ActivityTile
										activity={activity}
									/>
								</Grid>
							);
						})}
					</Grid>
				);

			case 'cards':
				return (
					<PaddingWrap>
						<Grid container spacing={3}>
							{activities.map((activity:Activity) => {
								return(
									<Grid key={activity.id} xs={gridColumnWidth}>
										<ActivityCard
											activity={activity}
										/>
									</Grid>
								);
							})}
						</Grid>
					</PaddingWrap>
				);
		}
	}
	
	return (
		<>
			{
				activityCategory && (
					<ActivityCategoryDisplay activityCategory={activityCategory} />
				)
			}
			{renderActivityGridLayout(activities, layout)}
		</>
	);
};

export default ActivityGrid;